import type { RouteObject } from 'react-router';
import { page } from '@/lib/lazy-route';

const assets = () => import('./assets');
const checklists = () => import('./checklists');
const configurations = () => import('./configurations');
const documents = () => import('./documents');
const passwords = () => import('./passwords');
const vault = () => import('./vault');

// Documentation (IT Glue). Owned by the docs module. URLs match the links global search builds.
export const routes: RouteObject[] = [
  // B1: the main-menu Passwords page across every organization.
  { path: 'passwords', lazy: page(vault, (m) => m.PasswordsPage) },
  // B2: My Vault, the signed-in user's personal passwords.
  { path: 'passwords/my-vault', lazy: page(vault, (m) => m.MyVaultPage) },
  // M14 (track 5): expiring assets, warranties, SSL certificates and domains.
  { path: 'passwords/expiring', lazy: page(() => import('./expiring'), (m) => m.ExpiringPage) },
  { path: 'knowledge', lazy: page(documents, (m) => m.KnowledgePage) },
  { path: 'knowledge/settings', lazy: page(() => import('./knowledge-settings'), (m) => m.KnowledgeSettingsPage) },
  { path: 'knowledge/new', lazy: page(documents, (m) => () => <m.KnowledgeEditPage isNew />) },
  { path: 'knowledge/:documentId', lazy: page(documents, (m) => m.KnowledgeArticlePage) },
  { path: 'knowledge/:documentId/edit', lazy: page(documents, (m) => m.KnowledgeEditPage) },
];

export const orgRoutes: RouteObject[] = [
  { path: 'configurations', lazy: page(configurations, (m) => m.OrgConfigurationsPage) },
  { path: 'configurations/:configurationId', lazy: page(configurations, (m) => m.ConfigurationDetailPage) },
  { path: 'passwords', lazy: page(passwords, (m) => m.OrgPasswordsPage) },
  { path: 'passwords/:passwordId', lazy: page(passwords, (m) => m.PasswordDetailPage) },
  { path: 'documents', lazy: page(documents, (m) => m.OrgDocumentsPage) },
  { path: 'documents/new', lazy: page(documents, (m) => () => <m.OrgDocumentEditPage isNew />) },
  { path: 'documents/:documentId', lazy: page(documents, (m) => m.OrgDocumentPage) },
  { path: 'documents/:documentId/edit', lazy: page(documents, (m) => m.OrgDocumentEditPage) },
  { path: 'checklists', lazy: page(checklists, (m) => m.OrgChecklistsPage) },
  { path: 'checklists/:checklistId', lazy: page(checklists, (m) => m.ChecklistRunPage) },
  { path: 'assets/:typeId', lazy: page(assets, (m) => m.OrgAssetsPage) },
  { path: 'assets/:typeId/:assetId', lazy: page(assets, (m) => m.AssetDetailPage) },
  // B8: domain and SSL monitoring.
  { path: 'monitoring', lazy: page(() => import('./monitoring'), (m) => m.OrgMonitoringPage) },
];
